import React from 'react';
import { connect } from 'react-redux';

import { makeGetTask, makeIsDependant } from 'selectors/tasks';

import { isTempId } from 'utils/helpers';
import { isSubtask } from 'utils/task';

import TaskCompleteToggle from 'components/TaskCompleteToggle';

const TaskCompleteWrap = ({ id, dependantOn, isTemp, isSubtask, completed, projectId, dark, size, tickOnly, checkSubtasks, onChange }) => (
    <TaskCompleteToggle
        id={id}
        dependantOn={dependantOn}
        completed={completed}
        disabled={isTemp}
        projectId={projectId}
        dark={dark}
        size={size}
        tickOnly={tickOnly}
        isSubtask={isSubtask}
        checkSubtasks={!isSubtask && checkSubtasks}
        selectListDisabled={isSubtask}
        onChange={onChange}
    />
);

const makeMapStateToProps = () => {
    const getTask = makeGetTask();
    const isDependant = makeIsDependant();

    return ({ tasks, milestones }, ownProps) => {
        const task = ownProps.id && getTask(tasks.items, ownProps.id);

        return {
            completed: task?.completed,
            projectId: task?.project,
            isTemp: isTempId(ownProps.id),
            isSubtask: isSubtask(task),
            // dependantOn: isDependant(ownProps.id, true, tasks.items, milestones.items)
        }
    }
}

export default connect(makeMapStateToProps)(TaskCompleteWrap);
